import React, { ReactNode } from "react";
import { StyledSlider, StyledTrack, StyledThumb } from "./style";

export interface MultiRangeSliderProps {
  min: number;
  max: number;
  value: number[];
  minDistance: number;
  onChange: (value: number | readonly number[], index: number) => void;

  /**
   * Provide a custom render function for the thumb value.
   */
  renderValueInThumb: (value: number) => ReactNode;
}

const MultiRangeSlider = ({
  min,
  max,
  value,
  minDistance = 1,
  onChange,
  renderValueInThumb = (val) => val,
}: MultiRangeSliderProps) => (
  <StyledSlider
    min={min}
    max={max}
    value={value}
    minDistance={minDistance}
    ariaLabel={["Lower thumb", "Upper thumb"]}
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ariaValuetext={(state: any) => `Thumb value ${state.valueNow}`}
    pearling
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    renderTrack={(props: any, state: any) => <StyledTrack {...props} index={state.index} />}
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    renderThumb={(props: any, state: any) => (
      <StyledThumb {...props}>{renderValueInThumb(state.valueNow)}</StyledThumb>
    )}
    onAfterChange={onChange}
  />
);

export default MultiRangeSlider;
